import * as yup from "yup";
import { isOibValid } from "ui/components/TextField/OibTextField/validation";
import { isEmailValid } from "ui/components/TextField/EmailTextField/emailUtils";
import { isWebUrlValid } from "ui/components/TextField/WebTextField/webUtils";

export const TENANT_EDIT_FORM_SCHEMA = yup.object().shape({
  tenantTypeId: yup
    .string()
    .nullable()
    .required("Molimo Vas da odaberete tip korisnika"),
  companyName: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete naziv tvrtke"),
      otherwise: (schema) => schema.notRequired(),
    }),
  firstName: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "P",
      then: (schema) => schema.required("Molimo Vas da unesete ime"),
      otherwise: (schema) => schema.notRequired(),
    }),
  lastName: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "P",
      then: (schema) => schema.required("Molimo Vas da unesete prezime"),
      otherwise: (schema) => schema.notRequired(),
    }),
  headquartersAddress: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete adresu sjedišta"),
      otherwise: (schema) => schema.notRequired(),
    }),
  phoneNumber: yup
    .string()
    .nullable()
    .required("Molimo Vas da unesete telefonski broj"),
  mobilePhoneNumber: yup
    .string()
    .nullable(),
  email: yup
    .string()
    .nullable()
    .test(
      "valid-email",
      "Neispravna email adresa",
      (value) => {
        if (!value) return true;
        return isEmailValid(value);
      }
    ),
  web: yup
    .string()
    .nullable()
    .test(
      "valid-web",
      "Neispravna web adresa",
      (value) => {
        if (!value) return true;
        return isWebUrlValid(value);
      }
    ),
  personalIdentificationNumber: yup
    .string()
    .nullable()
    .when("tenantTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete OIB"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test(
      "valid-oib",
      "Neispravan OIB",
      (value) => {
        if (!value) return true; // Let required handle empty values
        return isOibValid(value);
      }
    ),
  // IBAN se ne unosi na ovoj formi — bankovni računi imaju vlastitu listu i modal
  // (TenantBankAccountEditCard), koji ima svoju validaciju IBAN-a.
  timezone: yup
    .string()
    .nullable()
    .required("Molimo Vas da unesete vremensku zonu"),
});
